import { CmsPaperlessInstructionPanel } from '../../models/registration-confirmation/cms-paperless-instruction-panel.interface';

export const mockCmsPaperlessInstructionPanel: CmsPaperlessInstructionPanel = {
  paperlessInstructionPanelBody: 'Paperless documents',
  paperlessInstructionPanelTitle:
    "Going paperless means there's less post to deal with, file or recycle, so we send all your policy documents via email. If you still require a paper copy of your plan documents. Please visit our contact us page where you can call us, use our online form or write to us.",
};
